import { Component } from '@theme/component';

/**
 * IT PDP — description read-more.
 *
 * Also retires its own toggle: if the copy already fits inside the collapsed
 * height there is nothing to expand, and a "Read more" that does nothing is
 * worse than no affordance at all.
 */
class ItPdpDescription extends Component {
  requiredRefs = ['body', 'toggle'];

  #resizeObserver;

  connectedCallback() {
    super.connectedCallback();

    this.refs.toggle.addEventListener('click', this.#toggle);

    this.#syncToggleVisibility();
    this.#resizeObserver = new ResizeObserver(() => this.#syncToggleVisibility());
    this.#resizeObserver.observe(this.refs.body);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver?.disconnect();
  }

  #syncToggleVisibility() {
    const { body, toggle } = this.refs;
    if (body.classList.contains('is-open')) return;

    // 2px of slack: sub-pixel line heights routinely overflow by a hair.
    const overflows = body.scrollHeight > body.clientHeight + 2;

    toggle.hidden = !overflows;

    // The gradient fade means "there is more below". When the copy already
    // fits there is nothing below, so the fade would just dim the last line
    // for no reason. Drop the mask in that case. Masking does not affect
    // layout, so this cannot change the measurement above.
    body.classList.toggle('is-unclamped', !overflows);
  }

  #toggle = () => {
    const { body, toggle } = this.refs;
    const open = body.classList.toggle('is-open');

    toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
    toggle.setAttribute('aria-expanded', String(open));
  };
}

if (!customElements.get('it-pdp-description')) {
  customElements.define('it-pdp-description', ItPdpDescription);
}
